import type { Phrase } from './copy.js';

/** The table shell and the connection surface. */
export const ROOM = {
  /* ── Connection ───────────────────────────────────────────────────────── */
  'conn.reconnecting': {
    tl: 'Nawalan ka ng signal. Binabalik ka sa mesa…',
    en: 'You lost signal. Getting you back to the table…',
  },
  'conn.closed': {
    tl: 'Wala kang koneksyon. Kailangan ng internet para tumaya.',
    en: 'You are offline. You need a connection to play.',
  },
  'conn.superseded': {
    tl: 'Bukas ang laro mo sa ibang screen. Doon muna ang mesa.',
    en: 'Your game is open on another screen. The table is over there.',
  },
  'conn.take': { tl: 'Dito na lang', en: 'Play here instead' },
  'conn.state.open': { tl: 'Konektado', en: 'Connected' },
  'conn.state.connecting': { tl: 'Kumokonekta…', en: 'Connecting…' },
  'conn.state.reconnecting': { tl: 'Binabalik ka…', en: 'Reconnecting…' },
  'conn.state.closed': { tl: 'Naputol', en: 'Dropped' },
  'conn.state.superseded': { tl: 'Nasa ibang screen', en: 'On another screen' },
  'conn.state.idle': { tl: 'Wala pang linya', en: 'No line yet' },

  /* ── The room ─────────────────────────────────────────────────────────── */
  'room.view.label': { tl: 'Anggulo ng mesa', en: 'Table angle' },
  /* Was "2.5D", which described the rendering rather than the seat. */
  'room.view.seated': { tl: 'Upo', en: 'Seated' },
  'room.view.top': { tl: 'Tanaw', en: 'Top' },
  'room.view.reset': { tl: 'Ibalik ang anggulo', en: 'Reset the angle' },
  'room.view.reset.short': { tl: 'Balik', en: 'Reset' },
  'room.settled.title': { tl: 'Tapos na ang hand.', en: 'The hand is over.' },
  'room.settled.sub': { tl: 'Pindutin para sa resibo', en: 'Tap for the receipt' },
  'room.wait.title': { tl: 'Hinihintay ang kalaro…', en: 'Waiting for players…' },
  'room.wait.seated': {
    tl: '{filled} sa {total} ang nakaupo.',
    en: '{filled} of {total} seated.',
  },
  'room.wait.looking': { tl: 'Hinahanap ang mesa mo.', en: 'Finding your table.' },
  'room.wait.soon': { tl: 'Magsisimula agad pagkakumpleto.', en: 'Starts as soon as it fills.' },
  'room.wait.kubo': { tl: 'Hintayin ang barkada mo', en: 'Waiting on your crew' },
  'room.wait.public': { tl: 'Hinahanap pa ng kalaro', en: 'Still looking for players' },
  'room.wait.countdown': {
    tl: '{who} — kung wala pa sa {secs}s, AI ang uupo.',
    en: '{who} — if nobody comes in {secs}s, AI sits down.',
  },
  'room.wait.arriving': { tl: '{who} — uupo na ang AI.', en: '{who} — AI is sitting down now.' },
  'room.wait.nogame': {
    tl: 'Wala pang board dito para sa {venue}.',
    en: 'No board here yet for {venue}.',
  },
  'room.wait.nogame.sub': { tl: 'Malapit na.', en: 'Coming soon.' },
  'room.fill': { tl: 'Umpisa na — {n} AI', en: 'Start now — {n} AI' },
  'room.waiting.server': {
    tl: 'Naghihintay ng mesa mula sa server…',
    en: 'Waiting for a table from the server…',
  },
  'room.leave': { tl: 'Umalis', en: 'Leave' },
  'room.talk': { tl: 'Table talk', en: 'Table talk' },
  'room.miron': { tl: '{n} miron', en: '{n} watching' },
  'room.pot': { tl: 'Pot {pot}', en: 'Pot {pot}' },
  'room.tong': { tl: 'Tong (house): {pct}%', en: 'Rake (house): {pct}%' },
  'room.you': { tl: 'Ikaw', en: 'You' },
  'room.seat': { tl: 'Upuan {n}', en: 'Seat {n}' },
  'room.bot': { tl: 'AI', en: 'AI' },
} as const satisfies Record<string, Phrase>;
